const requireEnv = (name) => {
  const value = process.env[name];

  if (!value) {
    console.warn(`Missing Firebase config value: ${name}`);
    return "";
  }

  return value;
};

const firebaseConfigs = {
  development: {
    apiKey: requireEnv("REACT_APP_FIREBASE_DEV_API_KEY"),
    authDomain: "split-app-dev-e27d1.firebaseapp.com",
    projectId: "split-app-dev-e27d1",
    storageBucket: "split-app-dev-e27d1.firebasestorage.app",
    messagingSenderId: "272375315459",
    appId: "1:272375315459:web:3fcf6d8ca6dd3e50a16236",
    measurementId: "G-P6VPXQ8KCM"
  },
  production: {
    apiKey: requireEnv("REACT_APP_FIREBASE_PROD_API_KEY"),
    authDomain: "avocadoisextrabananasplit.firebaseapp.com",
    projectId: "avocadoisextrabananasplit",
    storageBucket: "avocadoisextrabananasplit.firebasestorage.app",
    messagingSenderId: "178088029915",
    appId: "1:178088029915:web:db70797f6f394a707fa6fe"
  }
};

// Determine which environment to use
const getEnvironment = () => {
  // For production builds, always use production config
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  
  // Only use development in actual development mode
  if (process.env.NODE_ENV === 'development') {
    return 'development';
  }
  
  // Default to production for safety
  return 'production';
};

// Get the configuration and ensure no Enterprise features are enabled
const config = firebaseConfigs[getEnvironment()];

export const firebaseConfig = {
  ...config,
  // Explicitly disable any enterprise features
  experimentalForceLongPolling: false
};

export const appId = getEnvironment() === 'development' ? 'split-app-dev-e27d1' : 'avocadoisextrabananasplit';
